import React, { useState, useEffect } from "react";
import { Column } from "@ant-design/plots";
import { Empty, Spin } from "antd";

const PosMultiLinePlotChart = (props) => {
  let sortedData = [];
  if (props.data && Array.isArray(props.data)) {
    sortedData = props.data.sort((a, b) => {
      return new Date(a.transactionDate) - new Date(b.transactionDate);
    });
  }

  const data = sortedData.map((item) => ({
    bankName: item.bankName,
    totalAmount: item.amount,
    transactionDate: new Date(item.transactionDate).toLocaleString("default", {
      month: "long",
    }),
  }));

  if (props.isLoading) {
    return (
      <div style={{ textAlign: "center", position: "relative" }}>
        <Spin size="small" />
      </div>
    );
  }

  if (data.length === 0) {
    return <Empty description="Yükleniyor" />;
  }

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("tr-TR", {
      style: "currency",
      currency: "TRY",
      minimumFractionDigits: 2,
    }).format(value);
  };

  const config = {
    data: data,
    xField: "transactionDate",
    yField: "totalAmount",
    seriesField: "bankName",
    xAxis: {
      title: {
        text: "Aylar"
      }
    },
    yAxis: {
      title: {
        text: "Toplam Tutar (TL)"
      },
      label: {
        formatter: (v) => {
          let formattedValue = "";

          if (v >= 1e6) {
            formattedValue = `${(v / 1e6).toFixed(1)} M`;
          } else if (v >= 1e3) {
            formattedValue = `${(v / 1e3).toFixed(1)} K`;
          } else {
            formattedValue = new Intl.NumberFormat("tr-TR", {
              style: "currency",
              currency: "TRY",
              minimumFractionDigits: 2,
            }).format(v);
          }
          return formattedValue;
        }
      },
    },
    legend: {
      position: "top",
    },
    smooth: true,
    animation: {
      appear: {
        animation: "path-in",
        duration: 5000,
      },
    },
    tooltip: {
      customContent: (title, data) => {
        const content = data
          .map((item, index) => {
            const formattedValue = new Intl.NumberFormat("tr-TR", {
              currency: "TRY",
              minimumFractionDigits: 2,
            }).format(item.value);

            return `
              <div style="margin-bottom: 10px;" >
                <span style="font-weight: bold; color: ${item.color}; margin-right: 8px;">●</span>
                <span >${item.name} :</span>
                <span style="float: right; margin-left: 10px; text-align: right;">${formattedValue} TL</span>
              </div>
            `;
          })
          .join("");

        return `
          <div style="font-size:18px;margin-top: 10px;">${title}</div>
          <div style="font-size:18px;margin-top: 20px; margin-bottom: 15px;">${content}</div>
        `;
      },
    },
  };

  return <Column {...config} />;
};

export default PosMultiLinePlotChart;
